/** @jsxImportSource @emotion/react */

import { vars } from "@imwebme/clay-token";
import type { ElementType, Ref } from "react";
import { forwardRef } from "react";
import { Typography } from "..";
import type { LabelProps } from "./Label.types";

const _Label = <Element extends ElementType>(
  { type = "primary", className, text, bold = true, sx, as, children }: LabelProps<Element>,
  ref: Ref<HTMLElement>,
) => {
  const Element = as || "label";

  return (
    <Element
      ref={ref as any}
      className={className}
      css={{
        display: "flex",
        gap: vars.spacing[1],
        alignItems: "center",
        sx,
      }}
    >
      <Typography
        variant={bold ? "label-medium-bold" : "label-medium"}
        colorToken={type === "primary" ? "text" : "textSub"}
      >
        {text}
      </Typography>

      {children}
    </Element>
  );
};

export const Label = forwardRef(_Label);

Label.displayName = "Label";
